import { Event } from '@mirai/data-sources';
import { ServiceUser } from '@mirai/services';

import { EVENT } from '../components/helpers';

export const logout = () => {
  Event.publish(EVENT.LOGGED_OUT);
  ServiceUser.logout();
};
